import type { LocaleCatalog } from '../types';

export const enUS: LocaleCatalog = {
  'consult_prompt.title': 'Transfer announcement',
  'consult_prompt.help': 'Generate the fixed announcement once and reuse the verified asset across the platform. Customers hear the announcement and hold music; the original agent hears ringback. Three-way audio resumes when the colleague joins.',
  'consult_prompt.ready': 'Ready to reuse',
  'consult_prompt.pending': 'Not prepared',
  'consult_prompt.prepare': 'Generate fixed announcement',
  'consult_prompt.confirm': 'Generate and verify',
  'consult_prompt.cancel': 'Cancel',
  'consult_prompt.billing': 'The first generation uses the current administrator account and standard TTS billing. An existing valid asset is reused, with no new synthesis for each transfer. Enterprise call flows and call audio settings are unchanged.',
  'consult_prompt.reason': 'Reason (at least 4 characters)',
  'consult_prompt.failed': 'Announcement preparation failed. Check the details before retrying.',
  'roles.permission_directory': 'Permission catalog',
  'roles.permission_column': "Permissions",
  'roles.permission_count': "{count} permissions",
  'roles.risk_column': "Permission risk levels",
  'roles.risk_explanation': "Counts describe the permissions assigned to this role by risk level; they do not indicate account problems.",
  'roles.risk_count': "{risk} · {count} permissions",
  'roles.risk.R0': "Basic information",
  'roles.risk.R1': "Low risk",
  'roles.risk.R2': "Moderate risk",
  'roles.risk.R3': "High risk",
  'roles.risk.R4': "Highest risk",
  'roles.risk.unknown': "Risk not yet confirmed",
  'roles.no_permissions': "No permissions assigned",
  'roles.all_permissions': "All (built in)",
  'roles.builtin_risk': "All risk levels included",
  'roles.builtin_explanation': "Super administrators have all built-in administrator permissions without individual selections. Highest-risk actions, such as crediting power, still require identity verification on the current device.",
  'roles.template_title': "This page configures a role permission template",
  'roles.template_help': "Selected changes do not take effect until saved. They apply to active administrators with a valid assignment to this role; data scope and identity verification still apply. Current assignment records: {count}.",
  'identity.required': "Verify your identity before creating an administrator",
  'identity.steps': "Your administrator role is authorized, but this device still needs identity verification. Enter the six-digit authenticator code to search users and submit a creation request.",
  'identity.setup': "Set up an authenticator in Login and security, then return and recheck your identity.",
  'identity.verify': "Verify and continue",
  'identity.recheck': "Recheck identity",
  'identity.failed': "Identity verification incomplete",
  'identity.reason': "Verify identity before creating an administrator",
  'identity.search_failed': "Platform user search failed",
  'topup.lost_authenticator': "If you lost your authenticator, contact a security administrator who can still verify to arrange a reset. If no administrator can verify, the system owner must use a separate operational recovery process instead of the code-based approval flow.",
  'topup.security_link': "Login and security",
  'topup.title': "Credit power",
  'topup.title_user': "Credit power to {name}",
  'topup.submit': "Confirm credit",
  'topup.cancel': "Cancel",
  'topup.amount': "Power amount",
  'topup.reason': "Reason (4–500 characters, required)",
  'topup.checking': "Checking identity verification…",
  'topup.setup_required': "Set up an authenticator before crediting power",
  'topup.setup_steps': "Open authenticator setup, enter your login password, scan the QR code with your authenticator app and enter its six-digit code. Return here and recheck when finished; your amount and reason will be preserved.",
  'topup.setup_link': "Set up authenticator",
  'topup.refresh': "Setup complete, recheck",
  'topup.verify_required': "Verify your identity before crediting power",
  'topup.verify_steps': "Enter the current six-digit code from your authenticator app, then confirm. Verification and this credit will complete on this page.",
  'topup.code': "Six-digit authenticator code",
  'topup.failed': "Credit not completed",
  'topup.user_required': "Select a user first",
  'topup.amount_required': "Enter a finite power amount of at least 0.01",
  'topup.reason_required': "Enter a reason between 4 and 500 characters",
  'topup.code_required': "Enter the current six-digit authenticator code",
  'topup.success': "Power credited",
  'topup.reload_failed': "Power was credited, but the list could not refresh. Refresh it manually.",
  'common.loading': 'Loading…',
  'common.page_loading': 'Loading page…',
  'auth.permission_loading': 'Checking administrator permissions…',
  'errors.permission_load_failed': 'Failed to load permission information',
  'errors.permission_unavailable': 'Administrator permissions are temporarily unavailable. Please try again.',
  'auth.check_again': 'Check again',
  'auth.sign_out': 'Sign out',
  'common.language_follow_system': 'System',
  'common.language_user_selected': 'Custom',
  'common.language': 'Language',
  'common.language_zh_cn': 'Simplified Chinese',
  'common.language_zh_tw': 'Traditional Chinese',
  'common.language_en_us': 'English',
};
